@if (editMode) {
  <div></div>
}
@if (!editMode && hideFromPreview !== true) {
  <div>
    <div class="assets-header">
      {{ assetsHeaderText }}
    </div>
    <div [innerHTML]="assetsDetails | safeHtml"></div>
  </div>
}
